import React from "react";
import { useTranslation } from "react-i18next";

function PageTitleServices() {
  const { t, i18n } = useTranslation(); // Import translation functions

  return (
    <>
      {/* Page Title */}
      <div className="page-title">
        <div className="heading">
          <div className="container">
            <div className="row d-flex justify-content-center text-center">
              <div className="col-lg-8">
                <h1
                  className="text-white"
                  style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
                >
                  {t("servicesTitle")}
                </h1>
                <p
                  className="mb-0 text-white"
                  style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
                >
                  {t("servicesDescription")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Page Title */}
    </>
  );
}

export default PageTitleServices;
